export const QUERY_KEYS = {
  GET_USER_DETAILS: "GET_USER_DETAILS",
  AGENT_MENU: "agent_menu",
  ADMIN_MENU: "menus",
  EXAM_DETAILS: "EXAM_DETAILS",
  USER: "USER",
  BLACK_LIST_AGENTS: "BLACK_LIST_AGENTS",
  BLACKLISTED_CHECK: "BLACKLISTED_CHECK",
  PAYMENT_RECEIPT_VIEW: "PAYMENT_RECEIPT_VIEW",
  AGING_DISCREPANCY: "AGING_DISCREPANCY",
  CATEGORIES: "CATEGORIES",
  GENDERS: "GENDERS",
  SALUTATIONS: "SALUTATIONS",
  OCCUPATIONS: "OCCUPATIONS",
  CASTE_CATEGORY: "CASTE_CATEGORY",
  MARITAL_STATUS: "MARITAL_STATUS",
  CITIES: "CITIES",
  STATES: "STATES",
  QUALIFICATION: "QUALIFICATION",
  PINCODES: "PINCODES",
  UNIVERSITY: "UNIVERSITY",
  BANK_ACCOUNT_TYPES: "BANK_ACCOUNT_TYPES",
  INSURER: "INSURER",
  INSURER_TYPES: "INSURER_TYPES",
  TRANSACTION: "TRANSACTION",
  YEARS_OF_PASSING: "YEARS_OF_PASSING",
  IFSC: "IFSC",
  DISCREPANCY_LIST: "DISCREPANCY_LIST",
  DISCREPANCY: "DISCREPANCY",
  TRAINING_DOCUMENTS: "TRAINING_DOCUMENTS",

  //RESCHEDULE
  RESCHEDULE_USER: "RESCHEDULE_USER",
  USER_DETAILS: "USER_DETAILS",
  USER_DOCUMENT: "USER_DOCUMENT",

  STAGES: "master_count",

  AGENT_MASTER: "AGENT_MASTER",
  AGENT_TYPES: "AGENT_TYPES",
  SINGLE_AGENT_TYPE: "SINGLE_AGENT_TYPE",
  RESCHEDULE_LIST: "RESCHEDULE_LIST",
  RESCHEDULE_RAISE: "RESCHEDULE_RAISE",
  RESCHEDULE_APPROVE: "RESCHEDULE_APPROVE",
  EXAM_DETAILS_RAISE: "EXAM_DETAILS_RAISE",

  //SERVICING
  GET_ENDORSEMENT_DISCREPANCY_LIST: "GET_ENDORSEMENT_DISCREPANCY_LIST",

  //EXAM-CONFIG
  LIST_EXAM_CONFIG: "LIST_EXAM_CONFIG",
  EXAM_QUESTIONS_LISTING:"EXAM_QUESTIONS_LISTING",
  NOC: "NOC",
};
